import { createContext, useContext } from 'react';

import type { PrintSettings } from '~/pages/LeLens/print/printSettings';

export type NativeReportPdfOptions = { title?: string };

export type NativeReportPdf = {
  /** Prints the report's screen copy with the same engine as the ⋮ Download PDF. */
  downloadPdf: (settings?: PrintSettings, options?: NativeReportPdfOptions) => void;
  ready: boolean;
  printing: boolean;
};

export const NativeReportPdfContext = createContext<NativeReportPdf>({
  downloadPdf: () => {
    throw new Error('PDF export is only available inside a native report.');
  },
  ready: false,
  printing: false,
});

export const useNativeReportPdf = () => useContext(NativeReportPdfContext);
